<template>
  <a-row>
    <g-master name="fmo_items_taxes"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              :parentData="inParentData"
              modalWidth="90%"
    >
      <template slot="expandedRowRender" slot-scope="{text}">
        <template v-for="ve in master.valoresExpandidos">
          {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
        </template>
      </template>
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[8,8]">
          <a-col v-bind="colOptions">
            <g-dropdown :label="$t('Artículo')"
                        :formItemConfig="fiOptions"
                        endpoint="fmo_items"
                        :decorator="['id_invoice_item', { rules: [{ required: true, message: 'Valor requerido' }]}]">
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Unidad')">
              <a-input-number style="width: 100%" step="1"
                              v-decorator="['invoice_und', { rules: [{ required: false}] }]"
              ></a-input-number>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Base')">
              <a-input-number style="width: 100%" step="1"
                              v-decorator="['invoice_base', { rules: [{ required: false}] }]"
                              :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                              :parser="value => value.replace(/\$\s?|(,*)/g, '')"
              ></a-input-number>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Cantidad')">
              <a-input-number style="width: 100%" step="1"
                              v-decorator="['ammount_l', { rules: [{ required: false}] }]"
                              :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                              :parser="value => value.replace(/\$\s?|(,*)/g, '')"
              ></a-input-number>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Descuento')">
              <a-input-number style="width: 100%" step="1"
                              v-decorator="['ammount_l_discount', { rules: [{ required: false}] }]"
                              :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                              :parser="value => value.replace(/\$\s?|(,*)/g, '')"
              ></a-input-number>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Comentario')">
              <a-textarea autoSize
                          v-decorator="['comments', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
    </g-master>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="LÍNEAS DE FACTURAS CTB" key="1">
        <invoices_lines_ctb v-if="idParent" :id_invoice_line="idParent"></invoices_lines_ctb>
        <span v-else>Seleccione una factura para ver más.</span>
      </a-tab-pane>
    </a-tabs>
  </a-row>
</template>

<script>
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'invoices_lines',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Artículo', dataIndex: 'item_name', sorter: true},
              {title: 'Unidad', dataIndex: 'invoice_und', sorter: true},
              {title: 'Base', dataIndex: 'invoice_base', sorter: true},
              {title: 'Cantidad', dataIndex: 'ammount_l', sorter: true},
              {title: 'Descuento', dataIndex: 'ammount_l_discount', sorter: true},
              {title: 'Comentario', dataIndex: 'comments', sorter: true}
            ],
            customSlots: ['expandedRowRender'],
            allowSelect: true,
            selectedRows: []
          },
          valoresExpandidos: [
            {label: 'Autor', column: 'created_by'},
            {label: 'Creado', column: 'created_on'}
          ],
          modalFieldsSetup: [
            {name: 'ammount_l'},
            {name: 'ammount_l_discount'},
            {name: 'comments'},
            {name: 'id_invoice'},
            {name: 'id_invoice_item'},
            {name: 'id_invoice_line'},
            {name: 'invoice_base'},
            {name: 'invoice_und'},
            {name: 'item_name'}
          ]
        }
      }
    },
    props: ['id_invoice'],
    computed: {
      inParentData () {
        return {
          id_invoice: this.id_invoice
        }
      },
      idParent () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Fmo/InvoicesLines.vue